import script from "./SettingsFormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsFormItem.vue?vue&type=script&setup=true&lang=js"

import "./SettingsFormItem.vue?vue&type=style&index=0&id=f6207e4e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6207e4e"]])

export default __exports__